import {
  View,
  TouchableOpacity,
  Image,
  TouchableNativeFeedback,
  Linking,
  Dimensions,
} from "react-native";
import React from "react";

import { normalize } from "@constants/metrics";
import color from "@constants/color";
import CustomerApp from "@assets/images/CustomerApp.png";
import ChevronRight from "@assets/svg/ChevronRight";
import { useSelector } from "react-redux";
import analytics from "@services/analytics";
import { ORDER_FLOW_EVENTS } from "@constants/analyticsEventsCT";
import Text from "./CustomText";

const GoToCustomerApp = ({
  slug,
  sku_id,
  price_tl_commission,
  price_tl_single_buy,
}) => {
  const { app_share_app_link } = useSelector((state) => state?.auth?.user);
  const sharingLink = `${app_share_app_link}?app_screen=ProductDetails&slug=${slug}&channel=cl_product_share`;

  const openCXApp = () => {
    analytics.trackEvent(ORDER_FLOW_EVENTS.GO_TO_CX_APP_CLICK, {
      sku_id,
      price: price_tl_single_buy,
      commission: price_tl_commission,
    });
    try {
      Linking.openURL(sharingLink);
    } catch (error) {
      alert("Something went wrong");
    }
  };

  return (
    <TouchableNativeFeedback
      onPress={openCXApp}
      background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
    >
      <View
        style={{
          padding: normalize(16),
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottomWidth: 1,
          borderBottomColor: "rgba(0, 0, 0, 0.1)",
          width: Dimensions.get("screen").width,
          overflow: "hidden",
        }}
      >
        <Text
          variant="body_text_4"
          style={{
            color: color.mediumBlack,
            flex: 0.5,
          }}
        >
          यह आइटम खरीदना चाहते हैं ?
        </Text>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <Image style={{ height: 24, width: 24 }} source={CustomerApp} />
          <Text
            variant="body_text_2"
            style={{
              color: color.mediumBlack,
              marginHorizontal: 8,
            }}
          >
            Go to Customer App
          </Text>
          <TouchableOpacity style={{ height: 14, width: 14 }}>
            <ChevronRight pathFill={color.primary} />
          </TouchableOpacity>
        </View>
      </View>
    </TouchableNativeFeedback>
  );
};

export default GoToCustomerApp;
